import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getOfficeStatusDetails = async () => {
  const { data } = await axios.get(
    `${api_base_url}/OfficeStatusDetails/OfficeStatusDetails`
  );
  return data;
};

export const getOfficeStatusDetailsInfo = async () => {
  const data = await axios.get(
    `${api_base_url}/OfficeStatusDetails/OfficeStatusDetails`
  );
  return data;
};

export const addOfficeStatusDetails = async (newOfficeStatusDetails) => {
  const { data } = await axios.post(
    `${api_base_url}/OfficeStatusDetails`,
    newOfficeStatusDetails
  );
  return data;
};

export const updateOfficeStatusDetails = async (updatedOfficeStatusDetails) => {
  const { data } = await axios.put(
    `${api_base_url}/OfficeStatusDetails/${updatedOfficeStatusDetails.officeStatusDetailsId}`,
    updatedOfficeStatusDetails
  );
  return data;
};

export const deleteOfficeStatusDetails = async (ids) => {
  const { data } = await axios.delete(`${api_base_url}/OfficeStatusDetails`, {
    data: ids,
  });

  return data;
};

//Search OfficeStatusDetails
export const searchOfficeStatusDetails = async (searchInputsData) => {
  if (searchInputsData === "") {
    searchInputsData = "0";
  }
  const data = {
    glNumber: parseInt(searchInputsData),
  };

  return await axios
    .post(`${api_base_url}/OfficeStatusDetails/SearchOfficeStatusDetails`, data)
    .then((res) => res.data);
};
